<template>
  <div class="chat_room_message_item" v-if="isCompleted">
    <div :class="clazz">
      <div
        :class="chatSystemClass(chatMessage)"
        v-for="(m, i) in systemMessage"
        v-bind:key="i"
      >
        {{ toSystemMessage(m) }}
      </div>
      {{ dateMessage }}
      <div
        class="btn_wrap"
        v-if="messageType === 'ASK_ESTIMATE' && isCreateMode"
      >
        <button class="btn bo" @click="createChatRoom()">
          바로 문의등록
        </button>
        <button class="btn" @click="openEstimationListModal">
          요청서 보내기
        </button>
      </div>
      <div v-if="fromSystem2">
        <div class="chat_box">
          <div class="prof seller">
            <div class="inner">
              <img
                src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
                alt=""
              />
            </div>
          </div>
          <div class="chat_con perce_chat_con">
            <div class="chat_txt">
              <div class="chat_title">퍼스 알림</div>
              <div
                v-for="(m, i) in systemMessage2"
                v-bind:key="i"
                class="chat_msg"
              >
                {{ toSystemMessage(m) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="prof seller"
        v-if="
          !fromSystem &&
            !fromSystem2 &&
            !isDate &&
            !fromMe &&
            !isExit &&
            !isInternetApplyNotice &&
            !isInternetVoucherOpen &&
            !isInternetPromotionKt2408Notice &&
            !isMobileApplyOpen &&
            !isMobileDealNotice
        "
      >
        <div class="inner" @click="openProfileModal">
          <img :src="profileImage" alt="" />
        </div>
      </div>
      <div
        :class="{
          chat_con:
            !isInternetApplyNotice &&
            !isInternetVoucherOpen &&
            !isInternetPromotionKt2408Notice &&
            !isMobileApplyOpen &&
            !isMobileDealNotice,
        }"
        v-if="!fromSystem && !fromSystem2 && !isDate"
      >
        <div v-for="(m, idx) in messages" v-bind:key="idx">
          <div :class="chatConClass(m)" v-if="true">
            {{ /*`(${m.messageIdx})`*/ }}
            {{ /*`(${m.messageIdx})`*/ }}
            {{ /*isNew(m) ? '[new]' : ''*/ }}
            {{ /*m.message*/ }}
            {{ /*m.type*/ }}
            <!-- 텍스트 메시지 -->
            <div
              class="chat_text_div"
              v-html="_toBR(_tagReplace(m.message.text))"
              v-if="m.message.text != '' && m.type === 'TEXT'"
            />
            <!-- 이미지 메시지 -->
            <img
              v-if="m.type === 'IMAGE'"
              :src="m.message.image"
              alt=""
              @load="handleImageLoaded(m)"
              @click="openImageModal(m)"
            />
            <!-- 견적요청 메시지 -->
            <!-- <button
              class="btn bo"
              style="margin-top: 1rem;"
              @click="openEstimationDetailModal(m)"
              v-if="m.type === 'ESTIMATE'"
            >
              견적을 요청합니다 <span class="underline">(보기)</span>
            </button> -->

            <!-- 견적요청 메시지 -->
            <ChatRoomEstimationItem
              v-if="m.type === 'ESTIMATE'"
              :EstimationId="m.message.estimateId"
              :chatroom="chatRoom"
              :isCustomer="isCustomer"
            />

            <!-- 사전예약 메시지 -->
            <ChatRoomBookingItem
              v-if="m.type === 'BOOKING'"
              :bookingModel="m.message.booking"
            />

            <!-- 인터넷커머스 견적 메시지 -->
            <ChatRoomInternetCommerceItem
              v-if="m.type === 'INTERNETCOMMERCE'"
              :internetCommerceModel="m.message.internetCommerce"
              :createdAt="m.createdAt"
              :isCustomer="isCustomer"
              :chatroom="chatRoom"
            />

            <!-- 인터넷커머스 프로모션 견적 메시지 INTERNETCOMMERCE_KT2408 -->
            <ChatRoomInternetCommerceItemKt2408
              v-if="m.type === 'INTERNETCOMMERCE_KT2408'"
              :internetCommerceKT2408Model="m.message.internetCommerceKT2408"
              :createdAt="m.createdAt"
              :isCustomer="isCustomer"
              :chatroom="chatRoom"
            />

            <!-- 인터넷 프로모션 공지 시스템 알림-->
            <ChatRoomInternetKt2408Notice
              v-if="isInternetPromotionKt2408Notice"
              :is-customer="isCustomer"
              :chatroom="chatRoom"
              @openInternetQuotationList="openInternetQuotationList"
              @openImageViewModal="val => $emit('openImageViewModal', val)"
              @report="$emit('reportStore')"
              @send="val => $emit('sendAutoMessage', val)"
            />

            <!-- 인터넷커머스 신청하기 -->
            <ChatRoomInternetCommerceApply
              v-if="m.type === 'INTERNETAPPLY'"
              :applyModel="m.message.internetApply"
              :isCustomer="isCustomer"
              :chatroom="chatRoom"
              :applyCreatedAt="m.createdAt"
            />

            <!-- 인터넷커머스 신청한 상세 -->
            <ChatRoomInternetCommerceApplySubmit
              v-if="m.type === 'INTERNETAPPLYSUBMIT'"
              :applySubmitModel="m.message.internetApplySubmit"
              :isCustomer="isCustomer"
              :chatroom="chatRoom"
              :applyCreatedAt="m.createdAt"
              @openInternetApplyVoucher="openInternetApplyVoucher"
              @openInternetApplyAddress="openInternetApplyAddress"
              @openApplyCancelModal="openApplyCancelModal"
            />

            <!-- 인터넷 신청 공지 시스템 알림-->
            <ChatRoomInternetApplyNotice
              v-if="isInternetApplyNotice"
              :is-customer="isCustomer"
              :chatroom="chatRoom"
              @openInternetQuotationList="openInternetQuotationList"
              @report="$emit('reportStore')"
              @send="val => $emit('sendAutoMessage', val)"
            />

            <!-- 인터넷 신청 열람 시스템 알림-->
            <ChatRoomInternetVoucherOpen
              v-if="isInternetVoucherOpen && isCustomer"
              :isType="m.type"
              :is-customer="isCustomer"
              @openSelfIdenModal="val => $emit('openSelfIdenModal', val)"
            />

            <!-- 견적서 보낸 메시지 (사장님) - 기존꺼 유지-->
            <ChatRoomQuotationItem
              v-if="m.type === 'QUOTATION'"
              :quotationModel="m.message.quotation"
            />

            <!-- 견적서 보낸 메시지 (사장님) - 새로바뀜 (20241205)-->
            <ChatRoomMobileEstimateItem
              v-if="m.type === 'MOBILE_ESTIMATE'"
              :mobileEstimateModel="m.message.mobileEstimate"
              :createdAt="m.createdAt"
            />

            <!-- 휴대폰 견적 메시지, 휴대폰 특가 견적 메시지 -->
            <ChatRoomMobileRequestItem
              v-if="m.type === 'MOBILE_REQUEST'"
              :mobileRequestModel="m.message.mobileRequest"
              :createdAt="m.createdAt"
            />

            <!-- 휴대폰 특가 메시지 -->
            <ChatRoomMobileDeal
              v-if="isMobileDealNotice && isCustomer"
              :mobileDealModel="m.message.mobileDeal"
            />

            <!-- 인터넷 프로모션 메시지 -->
            <ChatRoomInternetCommercePromotion
              v-if="m.type === 'INTERNET_PROMOTION'"
              :internetPromotionModel="m.message.internetPromotion"
            />

            <!-- 방문예약 메시지 -->
            <ChatRoomPromiseItem
              v-if="m.type === 'VISIT_PROMISE'"
              :visitPromiseModel="m.message.visitPromise"
              :isCustomer="isCustomer"
              :promiseCreatedAt="m.createdAt"
            />

            <!-- 휴대폰 개통 신청하기 -->
            <ChatRoomMobileApplySubmit
              v-if="m.type === 'MOBILE_APPLY_SUBMIT'"
              :applyModel="m.message.mobileApplySubmit"
              :isCustomer="isCustomer"
              :chatroom="chatRoom"
              :applyCreatedAt="m.createdAt"
              @openMobileApplyCancel="openMobileApplyCancel"
            />

            <!-- 휴대폰 개통신청서 열람 시스템 알림-->
            <ChatRoomMobileApplyOpen
              v-if="isMobileApplyOpen && isCustomer"
              :is-customer="isCustomer"
            />

            <!-- <div v-if="m.type === 'NOTICE'">{{ m.message.text }}</div> -->

            <button
              class="btn bo"
              @click="openQuotation(m)"
              style="margin-bottom:0.8rem;"
              v-if="m.type === 'QUOTATION'"
            >
              상세 보기
            </button>

            <button
              class="btn bo"
              @click="openMobileEstimateDetail(m)"
              style="margin-bottom:0.8rem;"
              v-if="m.type === 'MOBILE_ESTIMATE'"
            >
              상세 보기
            </button>

            <button
              class="btn bo"
              style="margin-bottom:0.8rem;"
              @click="openMobileDetail(m)"
              v-if="m.type === 'MOBILE_REQUEST'"
            >
              상세 보기
            </button>

            <button
              class="btn bo fw800"
              style="margin-bottom:0.8rem;padding:0;"
              @click="openMobileApplyForm(m, 'VISIT')"
              v-if="
                (m.type === 'QUOTATION' ||
                  (m.type === 'MOBILE_ESTIMATE' &&
                    m.message.mobileEstimate.openVisit == '1') ||
                  (m.type === 'MOBILE_REQUEST' &&
                    m.message.mobileRequest.openVisit == '1')) &&
                  isCustomer
              "
            >
              개통신청서 작성하기<span style="font-weight:700">(매장방문)</span>
            </button>

            <button
              class="btn bo fw800"
              @click="openMobileApplyForm(m, 'ONLINE')"
              v-if="
                (m.type === 'QUOTATION' ||
                  (m.type === 'MOBILE_ESTIMATE' &&
                    m.message.mobileEstimate.openOnline == '1') ||
                  (m.type === 'MOBILE_REQUEST' &&
                    m.message.mobileRequest.openOnline == '1')) &&
                  isCustomer
              "
            >
              개통신청서 작성하기<span style="font-weight:700">(비대면)</span>
            </button>

            <button
              class="btn bo"
              @click="openMobilePromiseView(m, isCustomer)"
              v-if="m.type === 'VISIT_PROMISE'"
            >
              상세 보기
            </button>
          </div>
        </div>
      </div>
      <div
        class="chat_time"
        v-if="
          !fromSystem &&
            !fromSystem2 &&
            !isDate &&
            !isExit &&
            !isInternetApplyNotice &&
            !isInternetVoucherOpen &&
            !isInternetPromotionKt2408Notice &&
            !isMobileApplyOpen &&
            !isMobileDealNotice
        "
      >
        <div
          class="chat_read"
          v-if="
            fromMe &&
              chatroomWatchMessageIdx >=
                messages[messages.length - 1].messageIdx
          "
        >
          {{ isReadText }}
        </div>
        {{ messageTime }}
      </div>
    </div>
    <div class="msg" v-if="chatRoom.type === 'SYSTEM' && fromMe">
      <div>문의가 접수 되었습니다.</div>
      <div>담당자가 문의를 확인한 후 답변 드릴 예정 입니다.</div>
      <div>문의에 따라 답변이 늦어질 수 있는 점 양해 부탁 드립니다.</div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import ChatRoomQuotationItem from '@/common/components/chat/components/ChatRoomQuotationItem.vue';
import ChatRoomMobileEstimateItem from '@/common/components/chat/components/ChatRoomMobileEstimateItem.vue';
import ChatRoomBookingItem from '@/common/components/chat/components/ChatRoomBookingItem.vue';
import ChatRoomEstimationItem from '@/common/components/chat/components/ChatRoomEstimationItem.vue';
import ChatRoomInternetCommerceItem from '@/common/components/chat/components/ChatRoomInternetCommerceItem.vue';
import ChatRoomInternetCommerceItemKt2408 from '@/common/components/chat/components/ChatRoomInternetCommerceItemKt2408.vue';
import ChatRoomInternetKt2408Notice from '@/common/components/chat/components/ChatRoomInternetKt2408Notice.vue';
import ChatRoomInternetCommerceApply from '@/common/components/chat/components/ChatRoomInternetCommerceApply.vue';
import ChatRoomInternetCommerceApplySubmit from '@/common/components/chat/components/ChatRoomInternetCommerceApplySubmit.vue';
import ChatRoomInternetApplyNotice from '@/common/components/chat/components/ChatRoomInternetApplyNotice.vue';
import ChatRoomInternetVoucherOpen from '@/common/components/chat/components/ChatRoomInternetVoucherOpen.vue';

import ChatRoomMobileRequestItem from '@/common/components/chat/components/ChatRoomMobileRequestItem.vue';

import ChatRoomInternetCommercePromotion from '@/common/components/chat/components/ChatRoomInternetCommercePromotion.vue';

import ChatRoomPromiseItem from '@/common/components/chat/components/ChatRoomPromiseItem.vue';

import ChatRoomMobileApplySubmit from '@/common/components/chat/components/ChatRoomMobileApplySubmit.vue';

import ChatRoomMobileApplyOpen from '@/common/components/chat/components/ChatRoomMobileApplyOpen.vue';

import ChatRoomMobileDeal from '@/common/components/chat/components/ChatRoomMobileDeal.vue';

import {
  toBR,
  tagReplace,
  setProfile,
  setShopProfile,
} from '@common/lib/common/utils';
import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';
export default {
  components: {
    ChatRoomQuotationItem,
    ChatRoomMobileEstimateItem,
    ChatRoomBookingItem,
    ChatRoomEstimationItem,
    ChatRoomInternetCommerceItem,
    ChatRoomInternetCommerceItemKt2408,
    ChatRoomInternetKt2408Notice,
    ChatRoomInternetCommerceApply,
    ChatRoomInternetCommerceApplySubmit,
    ChatRoomMobileRequestItem,
    ChatRoomInternetCommercePromotion,
    ChatRoomPromiseItem,
    ChatRoomInternetApplyNotice,
    ChatRoomInternetVoucherOpen,
    ChatRoomMobileApplySubmit,
    ChatRoomMobileApplyOpen,
    ChatRoomMobileDeal,
  },
  props: {
    chatRoom: Object,
    chatMessage: Array,
    userId: Number,
    members: Array,
    isCreateMode: Boolean,
    lastReadMessageIdx: Number,
    connectMessageIdx: Number,
    chatroomWatchMessageIdx: Number,
    shopVouchersLimit: Boolean,
  },
  data() {
    return {
      isReadText: '읽음',
      isCurrentMessageIdx: 0,
      isCompleted: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.isCompleted = true;
    });
  },
  // mounted() {
  //   this.$nextTick(() => {
  //   });
  // },
  computed: {
    // ...chatMapGetters({
    //   chatroom_watch: chatGetters.CHATROOM_WATCH,
    // }),
    messageType() {
      return this.chatMessage ? this.chatMessage[0].type : null;
    },
    clazz() {
      //msg, msg bg, chat_date, chat_box, chat_box_me
      //msg, msg bg --> system 메시지
      //chat_date 날짜 변경시.
      //chat_box, chat_box me -->TEXT
      const type = this.messageType;
      // console.log(type);
      // console.log(this.chatMessage);

      console.log('this.messageType.....');
      console.log(this.messageType);

      if (type === 'SYSTEM' || type === 'NOTICE') {
        return 'msg';
      } else if (
        type === 'SYSTEM_2' ||
        type === 'INTERNET_APPLY_NOTICE' ||
        type === 'INTERNET_VOUCHER_OPEN_NOTICE' ||
        type === 'INTERNET_PROMOTION_KT2408_NOTICE' ||
        type === 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE' ||
        type === 'MOBILE_APPLY_OPEN_NOTICE' ||
        type === 'MOBILE_DEAL_NOTICE'
      ) {
        return 'perce_msg';
      } else if (type === 'ASK_FOLLOW' || type === 'ASK_ESTIMATE') {
        return 'msg bg';
      } else if (type === 'DATE') {
        return 'chat_date';
      } else {
        //TEXT, IMAGE, FILE, VIDEO, ESTIMATE, QUOTATION
        return `chat_box ${this.fromMe ? 'me' : ''}`;
      }
    },
    fromSystem() {
      const type = this.messageType;
      return (
        type === 'ASK_FOLLOW' ||
        type === 'ASK_ESTIMATE' ||
        type === 'SYSTEM' ||
        type === 'NOTICE'
      );
    },
    fromSystem2() {
      const type = this.messageType;
      return type === 'SYSTEM_2';
    },
    fromMe() {
      const { userId } = this.chatMessage[0];
      return userId === this.userId;
    },
    isDate() {
      return this.messageType === 'DATE';
    },
    isText() {
      return this.messageType === 'TEXT';
    },
    isImage() {
      return this.messageType === 'IMAGE';
    },
    isEstimate() {
      return this.messageType === 'ESTIMATE';
    },
    isQuotation() {
      return this.messageType === 'QUOTATION';
    },
    isMobileEstimate() {
      return this.messageType === 'MOBILE_ESTIMATE';
    },
    isBooking() {
      return this.messageType === 'BOOKING';
    },
    isInternetCommerce() {
      return this.messageType === 'INTERNETCOMMERCE';
    },
    isInternetCommerceKt2408() {
      return this.messageType === 'INTERNETCOMMERCE_KT2408';
    },
    isInternetApply() {
      return this.messageType === 'INTERNETAPPLY';
    },
    isInternetApplySubmit() {
      return this.messageType === 'INTERNETAPPLYSUBMIT';
    },
    isInternetApplyNotice() {
      return this.messageType === 'INTERNET_APPLY_NOTICE';
    },
    isInternetPromotionKt2408Notice() {
      // mutations.js 에 추가필요
      return this.messageType === 'INTERNET_PROMOTION_KT2408_NOTICE';
    },
    isInternetVoucherOpen() {
      return (
        this.messageType === 'INTERNET_VOUCHER_OPEN_NOTICE' ||
        this.messageType === 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE'
      );
    },
    isMobileRequest() {
      return this.messageType === 'MOBILE_REQUEST';
    },
    isVisitPromise() {
      return this.messageType === 'VISIT_PROMISE';
    },
    isExit() {
      return this.messageType === 'EXIT';
    },
    isInternetPromotion() {
      return this.messageType === 'INTERNET_PROMOTION';
    },
    isMobileApplySubmit() {
      return this.messageType === 'MOBILE_APPLY_SUBMIT';
    },
    isMobileApplyOpen() {
      return this.messageType === 'MOBILE_APPLY_OPEN_NOTICE';
    },
    isMobileDealNotice() {
      return this.messageType === 'MOBILE_DEAL_NOTICE';
    },
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
    systemMessage() {
      if (this.fromSystem) {
        const message = this.chatMessage[0].message;
        const { text } = message;
        //return text.split('\n').map(m => `<div>${m}</div>`);
        return text.split('\n');
      }
      return [];
    },
    systemMessage2() {
      if (this.fromSystem2) {
        const message = this.chatMessage[0].message;
        const { text } = message;
        //return text.split('\n').map(m => `<div>${m}</div>`);
        // console.log('111111111111');
        // console.log(this.chatMessage[0]);
        return text.split('\n');
      }
      return [];
    },
    dateMessage() {
      if (this.isDate) {
        const message = this.chatMessage[0].message;
        const { date } = message;
        return date;
      }
      return null;
    },
    messages() {
      if (
        this.isText ||
        this.isImage ||
        this.isEstimate ||
        this.isQuotation ||
        this.isMobileEstimate ||
        this.isBooking ||
        this.isInternetCommerce ||
        this.isInternetCommerceKt2408 ||
        this.isInternetApply ||
        this.isInternetApplySubmit ||
        this.isInternetApplyNotice ||
        this.isInternetPromotionKt2408Notice ||
        this.isInternetVoucherOpen ||
        this.isMobileRequest ||
        this.isVisitPromise ||
        this.isInternetPromotion ||
        this.isMobileApplySubmit ||
        this.isMobileApplyOpen ||
        this.isMobileDealNotice
      ) {
        console.log('this.chatMessage');
        console.log(this.chatMessage);
        const messages = this.chatMessage;
        return messages;
      }
      return null;
    },
    messageTime() {
      const { createdAt } = this.chatMessage[0];
      return format(parseISO(createdAt), 'HH:mm');
    },
    // messageRead() {
    //   // const { read } = this.chatMessage[0];
    //   // return format(parseISO(createdAt), 'HH:mm');
    // },
    member() {
      const { userId } = this.chatMessage[0];
      const member = this.chatRoom.chatMembers.find(m => m.userId === userId);
      return member;
    },
    profileImage() {
      const member = this.member;
      if (member) {
        if (member.user.roles === '21') {
          console.log('this.chatRoom');
          console.log(this.chatRoom);
          if (this.chatRoom.store.storeProfileImage)
            return this.chatRoom.store.storeProfileImage;
          else
            return this.setShopProfileImg(
              this.chatRoom.store.name,
              this.chatRoom.store.id,
            );
        } else if (member.user.roles === '99') {
          return require('@/assets/front/images/v2/profiles/img_perce_prof.png');
        } else {
          console.log(member.user.photo);
          if (member.user.photo == null) {
            return require(`@/assets/front/images/v2/profiles/img_profile_${this.getProfileNum(
              member.user.id,
            )}.png`);
          } else {
            return member.user.photo;
          }
        }
      }
      return null;
    },
  },
  methods: {
    // ...chatMapActions([chatActions.FETCH_CHATROOM_WATCH]),
    _toBR(str) {
      return toBR(str);
    },
    _tagReplace(str) {
      return tagReplace(str);
    },
    chatConClass(message) {
      const { type } = message;
      if (type === 'TEXT') return 'chat_txt';
      else if (type === 'IMAGE') return 'chat_img';
      else if (type === 'ESTIMATE') return '';
      else if (type === 'QUOTATION') return 'chat_table';
      else if (type === 'MOBILE_ESTIMATE') return 'chat_table';
      else if (type === 'BOOKING') return 'chat_table';
      else if (type === 'INTERNETCOMMERCE') return 'chat_table';
      else if (type === 'INTERNETAPPLY') return 'chat_table';
      else if (type === 'INTERNET_APPLY_NOTICE') return '';
      else if (type === 'INTERNETAPPLYSUBMIT') return 'chat_table';
      else if (type === 'MOBILE_REQUEST') return 'chat_table';
      else if (type === 'VISIT_PROMISE') return 'chat_table';
      else if (type === 'MOBILE_APPLY_SUBMIT') return 'chat_table';
      else if (type === 'MOBILE_APPLY_OPEN_NOTICE') return '';
      else if (type === 'MOBILE_DEAL_NOTICE') return '';
    },
    chatTextClass(message) {
      if (message) {
        console.log('chatTextClass');
        console.log(message);
        if (message.match(/(#<#)(.*?)(#>#)/g)) {
          let cls2 = message.match(/(#<#)(.*?)(#>#)/g);
          cls2 = cls2[0];
          cls2 = cls2.replace(/(#(>|<)#)/g, '');
          return cls2;
        }
      }
      return '';
    },
    chatSystemClass(chatMessage) {
      console.log(chatMessage);
      if (chatMessage[0].type == 'NOTICE') {
        return 'msg_notice';
      } else {
        return '';
      }
    },
    toSystemMessage(message) {
      if (message) message = message.replace(/(#<#)(.*?)(#>#)/g, '');
      return message;
    },
    isNew(message) {
      const messageIdx = message.messageIdx;
      /*if(this.lastReadMessageIdx === this.connectMessageIdx) {
        return messageIdx > this.lastReadMessageIdx && messageIdx < this.connectMessageIdx
      }else {
        return messageIdx > this.lastReadMessageIdx && messageIdx <= this.connectMessageIdx
      }*/
      return (
        messageIdx > this.lastReadMessageIdx &&
        messageIdx <= this.connectMessageIdx
      );
    },
    openEstimationListModal() {
      this.$emit('openEstimationListModal');
    },
    openEstimationDetailModal(m) {
      this.$emit('openEstimationDetailModal', m.message.estimateId);
    },
    openImageModal(m) {
      this.$emit('openImageModal', m.message.image);
    },
    openProfileModal(m) {
      const { type } = this.chatMessage;
      const member = this.member;

      if (type !== 'IMAGE') {
        this.$emit(
          'openProfileModal',
          member.userId,
          member.user.roles,
          member.user.nickname,
        );
      }
    },
    handleImageLoaded(m) {
      this.$emit('image-loaded', m);
    },
    openQuotation(m) {
      const quotation = m.message.quotation;
      this.$emit('openQuotation', quotation);
    },
    openMobileDetail(m) {
      console.log('mmmmmmmmmmm');
      console.log(m);
      const mobileRequest = m.message.mobileRequest;
      this.$emit('openMobileDetail', mobileRequest);
    },
    openMobileEstimateDetail(m) {
      console.log('openMobileEstimateDetail');
      console.log(m);
      const mobileEstimate = m.message.mobileEstimate;
      this.$emit('openMobileEstimateDetail', mobileEstimate);
    },
    openMobileApplyForm(m, openType) {
      console.log('openMobileApplyForm');
      console.log(m);
      let estimateId = '';
      if (m.type == 'MOBILE_ESTIMATE') {
        estimateId = m.message.mobileEstimate.estimateId;
      } else if (m.type == 'MOBILE_REQUEST') {
        estimateId = m.message.mobileRequest.estimateId;
      }

      this.$emit('openMobileApplyForm', estimateId, openType);
    },
    openMobilePromiseView(m, isCustomer) {
      const visitPromise = m.message.visitPromise;
      this.$emit('openMobilePromiseView', visitPromise, isCustomer);
    },
    createChatRoom() {
      this.$emit('createChatRoom');
    },
    openInternetApplyAddress(applyId) {
      this.$emit('openInternetApplyAddress', applyId);
    },
    openInternetApplyVoucher(applyId) {
      this.$emit('openInternetApplyVoucher', applyId);
    },
    openInternetQuotationList() {
      this.$emit('openInternetQuotationList');
    },
    async getShopVouchersLimit(applyId) {
      this.$emit('getShopVouchersLimit', applyId);
    },
    openApplyCancelModal(applyId) {
      this.$emit('openApplyCancelModal', applyId);
    },
    openMobileApplyCancel(applyId) {
      this.$emit('openMobileApplyCancel', applyId);
    },
    // readTxt() {
    //   this.isReadText = '';
    //   console.log('readTxt');
    //   console.log(this.chatMessage[0].messageIdx);
    //   console.log(this.chatroomWatchMessageIdx);
    //   if (this.chatMessage[0].messageIdx <= this.chatroomWatchMessageIdx) {
    //     // return '읽음';
    //     this.isReadText = '읽음';
    //   } else {
    //     this.isReadText = '';
    //   }
    //   // });
    // },
    openSystemModal(type) {
      if (type === 'REPORT') {
        // 매장신고
        this.$emit('reportStore');
      }
    },
    getProfileNum(userId) {
      return setProfile(userId);
    },
    setShopProfileImg(shopName, shopId) {
      let path = setShopProfile(shopName, shopId, '72x72', '12');

      return path;
    },
  },
};
</script>
